<template>
    <div>
        <div class="unifiSettingsSection">
          <div class="appRow">
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Personal Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="personaldetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Company Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="companyDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Address Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="addressDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Proof Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="proofDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Plan Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="planDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Login Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="loginDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Inventory Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="inventoryDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
              <div class="col--sm5">
                  <label class="appLabel appLabel--primary appLabel--boxAlign"> Other Details :</label>
              </div>
              <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <treeselect  :multiple="true" v-model="otherDetailsMap" :options="options" :searchable="true" :clearable="false" :default-expand-level="1"></treeselect>
              </div>
             
          </div>
          <div class="appFormFooter appFormFooter--flush appFormFooter--dark">
              <div class="appFormFooter__right">
                  <button class="jazeButton jazeButton--primary" type="button" @click="saveUserCategory">Save</button>            
              </div>
          </div>
        </div>
      <SuccessToaster :successMessage='successMessage' :sucesstoasterShow='successtoaster' v-if='successtoaster'></SuccessToaster>
      <ErrorToaster :errorMessage='errorMessage' :errortoasterShow='errortoaster' v-if='errortoaster'></ErrorToaster>      
    </div>
  </template>
  <script>
  import { ref,toRef,computed,onMounted } from 'vue';
  import Treeselect from "jaze-vue3-treeselect";
  import SuccessToaster from "@/components/Toaster/SuccessToaster.vue";
  import ErrorToaster from "@/components/Toaster/ErrorToaster.vue";
  import { usesettingsStore } from '@/store/settingsstore';
  import {overrideIsSelected} from '@/overrides/vue3-treeselect'
  export default {
      props: ["additionalFields","aditionalData"],  
      components: {
          Treeselect,
          SuccessToaster,
          ErrorToaster
      },
      mixins: [overrideIsSelected()],
      setup(props) {
          const  additionalFields = toRef(props,'additionalFields'); 
          const aditionalData=toRef(props,'aditionalData'); 
          console.log(aditionalData.value)
          const errorShow = ref( false )
        const errorMessage = ref( "" )
        const successtoaster = ref( false )
        const successMessage = ref( "" )
        const errortoaster = ref( false )
        const personaldetailsMap=ref([]);
        const companyDetailsMap=ref([]);
        const addressDetailsMap=ref([]);
        const proofDetailsMap=ref([]);
        const planDetailsMap=ref([]);
        const loginDetailsMap=ref([]);
        const inventoryDetailsMap=ref([]);
        const otherDetailsMap=ref([]);
       const metaFieldOptions = computed(() => {
            var metaFieldArr = [];
            if (
                additionalFields.value != undefined &&
                additionalFields.value.length != 0
            ) {
                for (let i = 0; i < additionalFields.value.length; i++) {
                    metaFieldArr.push({
                        id: String(additionalFields.value[i].MetaFieldName.id),
                        label: additionalFields.value[i].MetaFieldName.name,
                    });
                }
            }
            return metaFieldArr;
        })
        personaldetailsMap.value=aditionalData.value.personaldetailsMap
        companyDetailsMap.value=aditionalData.value.companyDetailsMap
        addressDetailsMap.value=aditionalData.value.addressDetailsMap
        proofDetailsMap.value=aditionalData.value.proofDetailsMap
        planDetailsMap.value=aditionalData.value.planDetailsMap
        loginDetailsMap.value=aditionalData.value.loginDetailsMap
        inventoryDetailsMap.value=aditionalData.value.inventoryDetailsMap
        otherDetailsMap.value=aditionalData.value.otherDetailsMap

        const options = metaFieldOptions.value;
          const settingsStore = usesettingsStore();
          
          const saveUserCategory = () => {
            var data = {
                "personaldetailsMap": personaldetailsMap.value,
                "companyDetailsMap": companyDetailsMap.value,
                "addressDetailsMap":addressDetailsMap.value,
                "proofDetailsMap":proofDetailsMap.value,
                "planDetailsMap":planDetailsMap.value,
                "loginDetailsMap":loginDetailsMap.value,
                "inventoryDetailsMap":inventoryDetailsMap.value,
                "otherDetailsMap":otherDetailsMap.value,

            };
            // $store.dispatch("additionalFieldMappingValueSubmit", data).then(
            settingsStore.userCategoryFieldMappingValueSubmit(data).then(    
                (response) => {
                successtoaster.value = true;
                successMessage.value = response.message;
                setTimeout(
                    function () {
                    successtoaster.value = false;
                    }.bind(this),
                    3500
                );
                },
                (error) => {
                errortoaster.value = true;
                errorMessage.value = error;
                setTimeout(
                    function () {
                    errortoaster.value = false;
                    }.bind(this),
                    5500
                );
                console.log(error);
                }
            );
        }
        
  
          return {
              settingsStore,
              additionalFields,
              options,
              otherDetailsMap,
              inventoryDetailsMap,
              loginDetailsMap,
              planDetailsMap,
              proofDetailsMap,
              addressDetailsMap,
              companyDetailsMap,
              personaldetailsMap,
              saveUserCategory,
              errorShow,
            errorMessage,
            successtoaster,
            successMessage,
            errortoaster,
          }
      },
      
  };
  
  </script>